import { useState, useCallback } from 'react';
import { useGraphQL } from '../../../../apollo/useGraphQL';

export const useKpiChartData = () => {
  const { executeQuery } = useGraphQL();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  const fetchKpiChartData = useCallback(async (site, compCd, date = new Date(), range = "week") => {
    if (!compCd) {
      setError('회사 코드가 필요합니다.');
      return;
    }

    setLoading(true);
    setError(null);
    
    try {
      const dateString = date instanceof Date ? date.toISOString().split('T')[0] : date;
      const query = `
        query getKpiChartData($filters: [KpiSubscriptionFilter!]!, $site: String, $compCd: String) {
          getKpiChartData(filters: $filters, site: $site, compCd: $compCd) {
            kpiIndicatorCd
            kpiTitle
            categoryCd
            categoryNm
            chartType
            unit
            targetType
            targetValue
            chartData
            __typename
          }
        }
      `;
      
      const filters = [
        {
          date: dateString,
          range: range
        }
      ];
      
      const result = await executeQuery(query, {
        site: site,
        compCd: compCd,
        filters: filters
      });
      
      if (result.error) {
        throw new Error(result.error);
      }
      
      const chartData = result.data?.getKpiChartData;
      if (!chartData) {
        throw new Error('차트 데이터를 찾을 수 없습니다.');
      }
      setData(chartData);

    } catch (err) {
      console.error('KPI 차트 데이터 로딩 실패:', err);
      setError(err.message);
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [executeQuery]);

  return {
    data,
    loading,
    error,
    fetchKpiChartData
  };
};